import api from './api'

/**
 * Club Service
 * Handles all club-related API calls
 */
class ClubService {
  /**
   * Create new club
   * POST v1/clubs
   */
  async createClub(formData: FormData): Promise<any> {
    const response = await api.post('v1/clubs', formData)
    return response.data
  }

  /**
   * Get club details
   * GET v1/{club}
   */
  async getClub(clubUuid: string): Promise<any> {
    const response = await api.get(`v1/${clubUuid}`)
    return response.data
  }

  /**
   * Update club
   * PUT v1/clubs/{club}
   */
  async updateClub(clubUuid: string, formData: FormData): Promise<any> {
    // Add _method=PUT to FormData for Laravel
    formData.append('_method', 'PUT')

    const response = await api.post(`v1/clubs/${clubUuid}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  /**
   * Get all bank accounts for a club
   * GET v1/{club}/bank-accounts
   */
  async getBankAccounts(clubUuid: string): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/bank-accounts`)
    return response.data
  }

  /**
   * Create new bank account
   * POST v1/{club}/bank-accounts
   */
  async createBankAccount(clubUuid: string, data: any): Promise<any> {
    const response = await api.post(`v1/${clubUuid}/bank-accounts`, data)
    return response.data
  }

  /**
   * Update bank account
   * PUT v1/{club}/bank-accounts/{bankAccount}
   */
  async updateBankAccount(clubUuid: string, bankAccountUuid: string, data: any): Promise<any> {
    const response = await api.put(`v1/${clubUuid}/bank-accounts/${bankAccountUuid}`, data)
    return response.data
  }

  /**
   * Delete bank account
   * DELETE v1/{club}/bank-accounts/{bankAccount}
   */
  async deleteBankAccount(clubUuid: string, bankAccountUuid: string): Promise<any> {
    const response = await api.delete(`v1/${clubUuid}/bank-accounts/${bankAccountUuid}`)
    return response.data
  }

  /**
   * Get supervisors for a club
   * GET v1/{club}/supervisors
   */
  async getSupervisors(clubUuid: string): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/supervisors`)
    return response.data
  }

  /**
   * Add supervisor to a club
   * POST v1/{club}/supervisors
   */
  async addSupervisor(clubUuid: string, data: any): Promise<any> {
    const response = await api.post(`v1/${clubUuid}/supervisors`, data)
    return response.data
  }

  /**
   * Resend invitation to supervisor
   * POST v1/{club}/supervisors/{personUuid}/resend-invitation
   */
  async resendSupervisorInvitation(clubUuid: string, personUuid: string): Promise<any> {
    const response = await api.post(`v1/${clubUuid}/supervisors/${personUuid}/resend-invitation`)
    return response.data
  }

  /**
   * Remove supervisor from a club
   * DELETE v1/{club}/supervisors/{personUuid}
   */
  async removeSupervisor(clubUuid: string, personUuid: string): Promise<any> {
    const response = await api.delete(`v1/${clubUuid}/supervisors/${personUuid}`)
    return response.data
  }
}

export default new ClubService()
